import React from 'react';
import videoJs from 'video.js';
import 'video.js/dist/video-js.css';
import { styled } from '@mui/material';

const VideoJsPlayerContainer = styled('div', { name: 'VideoJsPlayerContainer' })(({ theme }) => ({
	width: '100%',
	height: '100%',
}));

const defaultOptions = {
	autoplay: false,
	controls: true,
	fluid: true,
	// width: '100%',
	// height: '100%',
};

export default class VideoJsPlayer extends React.Component {
	componentDidMount() {
		// instantiate videoJs
		this.player = videoJs(this.videoNode, { ...defaultOptions, ...this.props }, () => {
			// console.log('onPlayerReady', this)
		});
	}

	// destroy player on unmount
	componentWillUnmount() {
		if (this.player) {
			this.player.dispose();
		}
	}

	// wrap the player in a div with a `data-vjs-player` attribute
	// so video.js won't create additional wrapper in the DOM
	// see https://github.com/videojs/video.js/pull/3856
	// and we can not set className to that div, only style={}
	render() {
		return (
			<VideoJsPlayerContainer data-vjs-player>
				{/* <div data-vjs-player> */}
					<video ref={(node) => (this.videoNode = node)} className="video-js" />
				{/* </div> */}
			</VideoJsPlayerContainer>
		);
	}
}
